import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#07F",
      d: "M11.043 1.667c2.926 0 4.39 0 5.44.702.455.304.845.694 1.15 1.15.701 1.05.702 2.513.702 5.44v2.083c0 2.926 0 4.39-.703 5.44a4.2 4.2 0 0 1-1.149 1.15c-1.05.701-2.514.701-5.44.701H8.96c-2.926 0-4.39 0-5.44-.702a4.2 4.2 0 0 1-1.15-1.149c-.702-1.05-.702-2.514-.702-5.44V8.958c0-2.926 0-4.389.702-5.44A4.2 4.2 0 0 1 3.52 2.37c1.05-.702 2.514-.702 5.44-.702zM4.468 6.742c.09 4.354 2.26 6.97 6.066 6.97h.215v-2.49c1.398.14 2.456 1.164 2.88 2.49h1.975c-.542-1.981-1.968-3.077-2.859-3.495.89-.517 2.143-1.772 2.442-3.475h-1.795c-.39 1.382-1.544 2.637-2.643 2.756V6.742H8.955v4.829c-1.113-.28-2.518-1.633-2.58-4.829z"
    }, null, -1)
  ]))]))
}
export default { render: render }